import { Flex } from '@chakra-ui/react';
import UploadProduct from './modules/UploadProduct';
import { AppProvider } from './context/AppContext';
import ProductMapping from './modules/ProductMapping';
import Banner from '@pages/UploadMappingV2/components/ui/banner';
import { useFileUploadPopUp } from '@store/useFileUploadPopUp';
import { useEffect } from 'react';

export default function UploadMappingV2() {
    const { isOpen, reset } = useFileUploadPopUp();

    useEffect(() => {
        if (!isOpen) reset();
    }, []);

    return (
        <AppProvider>
            <Flex flexDir={'column'} gap="40px" flexWrap={'wrap'}>
                <Banner />
                <UploadProduct />
                <ProductMapping />
            </Flex>
        </AppProvider>
    );
}
